/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import { Field, useFormikContext } from "formik";
import { useState } from "react";

import ReactSelectWithFormik from "components/lib/Shared/DropdownSelect";
import Input from "components/lib/Shared/Input";
import options from "config/options/address";

// Residential Address Specific Details For Foreigner Company
const CountryCityForm = (props) => {
  const { field, form, disabled, disableEmailAddress } = props;
  const { setFieldValue } = useFormikContext();
  const [nationality, setNationality] = useState(() =>
    options.countries.find((country) => country.value === field?.value?.country)
  );

  const handleSelect = (type) => (option) => {
    setFieldValue(field.name, {
      ...field.value,
      [type]: option.value,
    });
    if (type === "country") {
      setNationality({ label: option.label, value: option.value });
    }
  };

  const handleSetValue = (e) => {
    setFieldValue(field.name, {
      ...field.value,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <div>
        <div className="grid grid-cols-6 gap-6">
          <div className="col-span-6 sm:col-span-2">
            <Input
              label="City"
              name="city"
              placeholder="Enter city"
              form={form}
              value={field.value?.city ?? ""}
              errorPath="location.city"
              disabled={disabled}
              onBlur={field.onBlur}
              onChange={handleSetValue}
            />
          </div>
          <div className="col-span-6 sm:col-span-2">
            <Field
              {...field}
              label="Country"
              value={nationality}
              name="country"
              form={form}
              component={ReactSelectWithFormik}
              options={options.countries}
              errorPath="location.country"
              placeholder="Select country"
              isDisabled={disabled}
              onBlur={field.onBlur}
              onChange={handleSelect("country")}
              isSearchable
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CountryCityForm;
